'use client';

import { useDeviceDetection } from '@/shared/hooks/useDeviceDetection';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import Products from './product/page';

export default function HomeContent() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { isMobile, isLoading } = useDeviceDetection();

  useEffect(() => {
    if (!isLoading && isMobile) {
      const hasSearchParams = searchParams.toString().length > 0;

      if (!hasSearchParams) {

        router.replace('/onboarding');
      }
    }
  }, [isMobile, isLoading, router, searchParams]);

  // 로딩 중이거나 모바일에서 리다이렉트 대기 중일 때
  if (isLoading || (isMobile && searchParams.toString().length === 0)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-8 h-8 border-t-2 border-blue-500 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="py-6">
      <Products />
    </div>
  );
}